import {AsyncPipe, NgClass}                                    from '@angular/common';
import {booleanAttribute, Component, inject, input, isDevMode} from '@angular/core';
import {MenuBaseService}                                       from '../../../menus/utils/menu-base.service';
import {UiThemeService}                                        from '../../../utils/ui-theme.service';

@Component({
			   selector   : 'app-ui-video-bg',
			   imports: [
				   NgClass,
				   AsyncPipe
			   ],
			   templateUrl: './ui-video-bg.component.html',
			   styleUrl   : './ui-video-bg.component.css'
		   })
export class UiVideoBgComponent {
	svcMenuBase = inject(MenuBaseService)
	svcUiTheme = inject(UiThemeService)
	protected readonly isDevMode = isDevMode;
	inlineBox = input(booleanAttribute(false), {transform: booleanAttribute});
}
